// extracted by mini-css-extract-plugin
export var addToCartButton = "_mc-b";
export var arrowButtonContainer = "_mc-9";
export var arrowButtonIcon = "_mc-a";
export var carouselArrowButton = "_mc-6";
export var carouselElementContainer = "_mc-1";
export var left = "_mc-7";
export var productDisplayCarouselContainer = "_mc-0";
export var productTileContainer = "_mc-2";
export var productTileImage = "_mc-4";
export var productTileImageContainer = "_mc-3";
export var productTileTitle = "_mc-5";
export var right = "_mc-8";
export var sliderOverflow = "_mc-c";